<template>
  <div v-if="$store.state.responsive.viewDesktopFilters" id="contract-filters">
    <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
      <div class="row">
        <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="name">Nombre</label>
            <input
                type="text"
                class="form-control generalInput"
                id="name"
                v-model.trim="name"
            />
          </div>
        </div>
        <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="surnames">Apellidos</label>
            <input
                type="text"
                class="form-control generalInput"
                id="surnames"
                v-model.trim="surnames"
            />
          </div>
        </div>
        <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="documentNumber">DNI/CIF</label>
            <input
                type="text"
                class="form-control generalInput"
                id="documentNumber"
                v-model.trim.lazy="v$.documentNumber.$model"
            />
            <div v-if="v$.documentNumber.$dirty">
              <small
                  class="form-text text-danger"
                  v-if="v$.documentNumber.dniOrCifNumber.$invalid"
              >DNI/CIF incorrecto</small
              >
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="contractNumber">Nº Contrato</label>
            <input
                type="text"
                class="form-control generalInput"
                id="contractNumber"
                v-model.trim="contractNumber"
            />
          </div>
        </div>
        <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="typeStatus">Tipo de estado</label>
            <VueNextSelect
                class="form-control generalInput"
                id="typeStatus"
                :options="typeStatusData"
                v-model.trim="typeStatus"
                placeholder=""
                searchable="true"
                clear-on-close="true"
                close-on-select
                @click="filterSubTypeStatusData()"
            >
            </VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="subtypeStatus">Subtipo de estado</label>
            <VueNextSelect
                class="form-control generalInput"
                id="subtypeStatus"
                :options="subtypeStatusData"
                v-model.trim="subtypeStatus"
                placeholder=""
                searchable="true"
                clear-on-close="true"
                close-on-select
                @click="filterStatusData()"
            >
            </VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group multipleSelect">
            <label class="generalLabel" for="status">Estado</label>
            <VueNextSelect
                id="status"
                class="form-control generalInput multiSelect"
                name="status"
                v-model="statusName"
                placeholder=""
                search-placeholder=""
                clear-on-close="true"
                searchable
                taggable
                :options="statusDescriptions"
                :multiple="true"
            >
            </VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="shop">Tienda</label>
            <input
                type="text"
                class="form-control generalInput"
                id="shop"
                v-model.trim="shop"
            />
          </div>
        </div>
        <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="channel">Canal</label>
            <VueNextSelect
                class="form-control generalInput"
                id="channel"
                v-model.trim="channel"
                :options="channelsData"
                placeholder=""
                close-on-select
            >
            </VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="tenant">Tenant</label>
            <VueNextSelect
                class="form-control generalInput"
                id="tenant"
                :options="tenantsData"
                v-model.trim="tenant"
                placeholder=""
                searchable="true"
                clear-on-close="true"
                close-on-select
            >
            </VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="from">Desde</label>
            <DatePicker v-model="from" mode="date" :model-config="modelConfig">
              <template v-slot="{ togglePopover }">
                <input
                    @click="togglePopover()"
                    class="form-control bg-white generalInput"
                    readonly
                    v-model="from"
                />
                <v-icon
                    name="ri-calendar-line"
                    scale="0.9"
                    class="generalSelect__iconDate"
                    @click="togglePopover()"
                />
              </template>
            </DatePicker>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="to">Hasta</label>
            <DatePicker v-model="to" mode="date" :model-config="modelConfig">
              <template v-slot="{ togglePopover }">
                <input
                    @click="togglePopover()"
                    class="form-control bg-white generalInput"
                    readonly
                    v-model="to"
                />
                <v-icon
                    name="ri-calendar-line"
                    scale="0.9"
                    class="generalSelect__iconDate"
                    @click="togglePopover()"
                />
              </template>
            </DatePicker>
          </div>
        </div>

        <div v-if="advancedSearch" class="d-block w-100 px-3">
          <div class="row">
            <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
              <div class="form-group">
                <label class="generalLabel" for="imei">IMEI</label>
                <input
                    type="text"
                    class="form-control generalInput"
                    id="imei"
                    v-model.trim="imei"
                />
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="form-group">
                <label class="generalLabel" for="policy">Póliza</label>
                <input
                    type="text"
                    class="form-control generalInput"
                    id="policy"
                    v-model.trim="policy"
                />
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="form-group">
                <label class="generalLabel" for="merchant">ID Transacción Origen</label>
                <input
                    type="text"
                    class="form-control generalInput"
                    id="merchant"
                    v-model.trim="merchant"
                />
              </div>
            </div>
            <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
              <div class="form-group">
                <label class="generalLabel" for="mobile">Móvil</label>
                <input
                    type="text"
                    class="form-control generalInput"
                    id="mobile"
                    v-model.trim="mobile"
                />
              </div>
            </div>
            <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
              <div class="form-group">
                <label class="generalLabel" for="email">Email</label>
                <input
                    type="text"
                    class="form-control generalInput"
                    id="email"
                    v-model.trim="email"
                />
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="form-group">
                <label class="generalLabel" for="direction">Dirección</label>
                <input
                    type="text"
                    class="form-control generalInput"
                    id="direction"
                    v-model.trim="direction"
                />
              </div>
            </div>
            <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
              <div class="form-group">
                <label class="generalLabel" for="reasonAccepted">Razón de aceptación</label>
                <VueNextSelect
                    class="form-control generalInput"
                    id="reasonAccepted"
                    :options="reasonAcceptedData"
                    v-model.trim="reasonAccepted"
                    placeholder=""
                    searchable="true"
                    clear-on-close="true"
                    close-on-select
                >
                </VueNextSelect>
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="form-group">
                <label class="generalLabel" for="realEndDateFrom">Fecha Baja Desde</label>
                <DatePicker v-model="realEndDateFrom" mode="date" :model-config="modelConfig">
                  <template v-slot="{ togglePopover }">
                    <input
                        @click="togglePopover()"
                        class="form-control bg-white generalInput"
                        readonly
                        v-model="realEndDateFrom"
                    />
                    <v-icon
                        name="ri-calendar-line"
                        scale="0.9"
                        class="generalSelect__iconDate"
                        @click="togglePopover()"
                    />
                  </template>
                </DatePicker>
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="form-group">
                <label class="generalLabel" for="realEndDateTo">Fecha Baja Hasta</label>
                <DatePicker v-model="realEndDateTo" mode="date" :model-config="modelConfig">
                  <template v-slot="{ togglePopover }">
                    <input
                        @click="togglePopover()"
                        class="form-control bg-white generalInput"
                        readonly
                        v-model="realEndDateTo"
                    />
                    <v-icon
                        name="ri-calendar-line"
                        scale="0.9"
                        class="generalSelect__iconDate"
                        @click="togglePopover()"
                    />
                  </template>
                </DatePicker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 d-flex justify-content-end align-items-end align-content-end mt-3">
              <a href="#" class="mr-4 mb-4 pb-2 d-flex align-items-center" @click="advancedSearchToggle()" v-if="!$store.state.roles.Backoffice_member_empresas">
                <v-icon name="la-minus-circle-solid" class="pr-2" scale="1.2"/>
                Búsqueda avanzada
              </a>
              <button class="btn generalSecondaryButton ml-2" @click="cleanSearch()">
                Limpiar
              </button>
              <button class="btn btn-primary generalPrimaryButton ml-2" v-bind:class="{ disabled: v$.$invalid || loadingButton }" :disabled="v$.$invalid || loadingButton">
                <span v-if="loadingButton" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-if="!loadingButton">Buscar</span>
              </button>
            </div>
          </div>
        </div>

        <div v-if="!advancedSearch" class="col-12 busqueda3 mt-4">
          <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
            <a href="#" class="mr-4 mb-4 pb-2 d-flex" @click="advancedSearchToggle()" v-if="!$store.state.roles.Backoffice_member_empresas">
              <v-icon name="bi-plus-circle" class="pr-2" scale="1.2" />
              Búsqueda avanzada
            </a>
            <button class="btn generalSecondaryButton" @click="cleanSearch()">
              Limpiar
            </button>
            <button
                class="btn btn-primary generalPrimaryButton"
                v-bind:class="{ disabled: v$.$invalid || isLoading }"
                :disabled="v$.$invalid || isLoading"
            >
              <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span v-else>Buscar</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div v-else>
    <div class="filterHeader link-primary d-flex align-items-center justify-content-between" data-toggle="collapse" href="#filterCollapse" role="button" aria-expanded="false" aria-controls="filterCollapse">
      <p class="m-0">FILTROS</p>
      <v-icon name="bi-filter" scale="1.5" />
    </div>
    <hr/>
    <div class="collapse" id="filterCollapse">
      <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
        <div class="row">
          <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="form-group">
              <label class="generalLabel" for="name">Nombre</label>
              <input
                  type="text"
                  class="form-control generalInput"
                  id="name"
                  v-model.trim="name"
              />
            </div>
          </div>
          <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="form-group">
              <label class="generalLabel" for="surnames">Apellidos</label>
              <input
                  type="text"
                  class="form-control generalInput"
                  id="surnames"
                  v-model.trim="surnames"
              />
            </div>
          </div>
          <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="form-group">
              <label class="generalLabel" for="documentNumber">DNI/CIF</label>
              <input
                  type="text"
                  class="form-control generalInput"
                  id="documentNumber"
                  v-model.trim.lazy="v$.documentNumber.$model"
              />
              <div v-if="v$.documentNumber.$dirty">
                <small
                    class="form-text text-danger"
                    v-if="v$.documentNumber.dniOrCifNumber.$invalid"
                >DNI/CIF incorrecto</small
                >
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="contractNumber">Nº Contrato</label>
              <input
                  type="text"
                  class="form-control generalInput"
                  id="contractNumber"
                  v-model.trim="contractNumber"
              />
            </div>
          </div>
          <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="form-group">
              <label class="generalLabel" for="typeStatus">Tipo de estado</label>
              <VueNextSelect
                  class="form-control generalInput"
                  id="typeStatus"
                  :options="typeStatusData"
                  v-model.trim="typeStatus"
                  placeholder=""
                  searchable="true"
                  clear-on-close="true"
                  close-on-select
                  @click="filterSubTypeStatusData()"
              >
              </VueNextSelect>
            </div>
          </div>
          <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="form-group">
              <label class="generalLabel" for="subtypeStatus">Subtipo de estado</label>
              <VueNextSelect
                  class="form-control generalInput"
                  id="subtypeStatus"
                  :options="subtypeStatusData"
                  v-model.trim="subtypeStatus"
                  placeholder=""
                  searchable="true"
                  clear-on-close="true"
                  close-on-select
                  @click="filterStatusData()"
              >
              </VueNextSelect>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group multipleSelect">
              <label class="generalLabel" for="status">Estado</label>
              <VueNextSelect
                  id="status"
                  class="form-control generalInput multiSelect"
                  name="status"
                  v-model="statusName"
                  placeholder=""
                  search-placeholder=""
                  clear-on-close="true"
                  searchable
                  taggable
                  :options="statusDescriptions"
                  :multiple="true"
              >
              </VueNextSelect>
            </div>
          </div>
          <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="form-group">
              <label class="generalLabel" for="shop">Tienda</label>
              <input
                  type="text"
                  class="form-control generalInput"
                  id="shop"
                  v-model.trim="shop"
              />
            </div>
          </div>
          <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="form-group">
              <label class="generalLabel" for="channel">Canal</label>
              <VueNextSelect
                  class="form-control generalInput"
                  id="channel"
                  v-model.trim="channel"
                  :options="channelsData"
                  placeholder=""
                  close-on-select
              >
              </VueNextSelect>
            </div>
          </div>
          <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="form-group">
              <label class="generalLabel" for="tenant">Tenant</label>
              <VueNextSelect
                  class="form-control generalInput"
                  id="tenant"
                  :options="tenantsData"
                  v-model.trim="tenant"
                  placeholder=""
                  searchable="true"
                  clear-on-close="true"
                  close-on-select
              >
              </VueNextSelect>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="from">Desde</label>
              <DatePicker v-model="from" mode="date" :model-config="modelConfig">
                <template v-slot="{ togglePopover }">
                  <input
                      @click="togglePopover()"
                      class="form-control bg-white generalInput"
                      readonly
                      v-model="from"
                  />
                  <v-icon
                      name="ri-calendar-line"
                      scale="0.9"
                      class="generalSelect__iconDate"
                      @click="togglePopover()"
                  />
                </template>
              </DatePicker>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="to">Hasta</label>
              <DatePicker v-model="to" mode="date" :model-config="modelConfig">
                <template v-slot="{ togglePopover }">
                  <input
                      @click="togglePopover()"
                      class="form-control bg-white generalInput"
                      readonly
                      v-model="to"
                  />
                  <v-icon
                      name="ri-calendar-line"
                      scale="0.9"
                      class="generalSelect__iconDate"
                      @click="togglePopover()"
                  />
                </template>
              </DatePicker>
            </div>
          </div>

          <div v-if="advancedSearch" class="d-block w-100 px-3">
            <div class="row">
              <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
                <div class="form-group">
                  <label class="generalLabel" for="imei">IMEI</label>
                  <input
                      type="text"
                      class="form-control generalInput"
                      id="imei"
                      v-model.trim="imei"
                  />
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="form-group">
                  <label class="generalLabel" for="policy">Póliza</label>
                  <input
                      type="text"
                      class="form-control generalInput"
                      id="policy"
                      v-model.trim="policy"
                  />
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="form-group">
                  <label class="generalLabel" for="merchant">ID Transacción Origen</label>
                  <input
                      type="text"
                      class="form-control generalInput"
                      id="merchant"
                      v-model.trim="merchant"
                  />
                </div>
              </div>
              <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
                <div class="form-group">
                  <label class="generalLabel" for="mobile">Móvil</label>
                  <input
                      type="text"
                      class="form-control generalInput"
                      id="mobile"
                      v-model.trim="mobile"
                  />
                </div>
              </div>
              <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
                <div class="form-group">
                  <label class="generalLabel" for="email">Email</label>
                  <input
                      type="text"
                      class="form-control generalInput"
                      id="email"
                      v-model.trim="email"
                  />
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="form-group">
                  <label class="generalLabel" for="direction">Dirección</label>
                  <input
                      type="text"
                      class="form-control generalInput"
                      id="direction"
                      v-model.trim="direction"
                  />
                </div>
              </div>
              <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
                <div class="form-group">
                  <label class="generalLabel" for="reasonAccepted">Razón de aceptación</label>
                  <VueNextSelect
                      class="form-control generalInput"
                      id="reasonAccepted"
                      :options="reasonAcceptedData"
                      v-model.trim="reasonAccepted"
                      placeholder=""
                      searchable="true"
                      clear-on-close="true"
                      close-on-select
                  >
                  </VueNextSelect>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="form-group">
                  <label class="generalLabel" for="realEndDateFrom">Fecha Baja Desde</label>
                  <DatePicker v-model="realEndDateFrom" mode="date" :model-config="modelConfig">
                    <template v-slot="{ togglePopover }">
                      <input
                          @click="togglePopover()"
                          class="form-control bg-white generalInput"
                          readonly
                          v-model="realEndDateFrom"
                      />
                      <v-icon
                          name="ri-calendar-line"
                          scale="0.9"
                          class="generalSelect__iconDate"
                          @click="togglePopover()"
                      />
                    </template>
                  </DatePicker>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="form-group">
                  <label class="generalLabel" for="realEndDateTo">Fecha Baja Hasta</label>
                  <DatePicker v-model="realEndDateTo" mode="date" :model-config="modelConfig">
                    <template v-slot="{ togglePopover }">
                      <input
                          @click="togglePopover()"
                          class="form-control bg-white generalInput"
                          readonly
                          v-model="realEndDateTo"
                      />
                      <v-icon
                          name="ri-calendar-line"
                          scale="0.9"
                          class="generalSelect__iconDate"
                          @click="togglePopover()"
                      />
                    </template>
                  </DatePicker>
                </div>
              </div>
              <div class="col-12 col-lg-6 mt-3 busqueda1" v-if="!$store.state.roles.Backoffice_member_empresas">
                <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
                  <a href="#" class="mr-4 mb-4 pb-2 d-flex" @click="advancedSearchToggle()">
                    <v-icon name="la-minus-circle-solid" class="pr-2" scale="1.2"/>
                    Búsqueda avanzada
                  </a>
                  <button class="btn generalSecondaryButton" @click="cleanSearch()">
                    Limpiar
                  </button>
                  <button class="btn btn-primary generalPrimaryButton" v-bind:class="{ disabled: v$.$invalid || loadingButton }" :disabled="v$.$invalid || loadingButton">
                    <span v-if="loadingButton" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span v-if="!loadingButton">Buscar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!advancedSearch" class="col-12 busqueda3 mt-4">
            <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
              <a href="#" class="mr-4 mb-4 pb-2 d-flex" @click="advancedSearchToggle()" v-if="!$store.state.roles.Backoffice_member_empresas">
                <v-icon name="bi-plus-circle" class="pr-2" scale="1.2" />
                Búsqueda avanzada
              </a>
              <button class="btn generalSecondaryButton" @click="cleanSearch()">
                Limpiar
              </button>
              <button class="btn btn-primary generalPrimaryButton" v-bind:class="{ disabled: v$.$invalid || loadingButton }" :disabled="v$.$invalid || loadingButton">
                <span v-if="loadingButton" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-if="!loadingButton">Buscar</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { DatePicker } from "v-calendar";
import VueNextSelect from "vue-next-select";
import axios from "axios";
import useVuelidate from "@vuelidate/core";

// Validación combinada DNI o CIF
const dniOrCifNumber = (value) => {
  if (value != "") {
    value = value.trim().toUpperCase();

    // Primero intentar validar como DNI
    var expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;
    if (expresion_regular_dni.test(value) === true) {
      var numero = value.substr(0, value.length - 1);
      numero = numero.replace("X", 0);
      numero = numero.replace("Y", 1);
      numero = numero.replace("Z", 2);
      var le = value.substr(value.length - 1, 1);
      numero = numero % 23;
      var letra = "TRWAGMYFPDXBNJZSQVHLCKET";
      letra = letra.substring(numero, numero + 1);
      if (letra == le) {
        return true;
      }
    }

    // Si no es DNI válido, intentar validar como CIF
    if (value.length === 9) {
      const firstLetter = value[0];
      if ("ABCDEFGHJNPQRSUVW".includes(firstLetter)) {
        // Es formato CIF, aceptarlo sin validación estricta del dígito de control
        // ya que algunos CIFs pueden tener letra en vez de número como control
        return true;
      }
    }

    return false;
  } else {
    return true;
  }
};

const validateCIF = (value) => {
  if (value != "") {
    value = value.trim().toUpperCase();

    if (value.length !== 9) {
      return false;
    }

    const firstLetter = value[0];
    if (!"ABCDEFGHJNPQRSUVW".includes(firstLetter)) {
      return false;
    }

    const lastDigit = parseInt(value[8]);
    let controlDigit = 0;
    let total = 0;
    for (let i = 1; i < 8; i += 2) {
      const c = parseInt(value[i]);
      total += c;
      total += [...(c * 2).toString()].reduce((sum, d) => sum + parseInt(d), 0);
    }
    controlDigit = (10 - (total % 10)) % 10;
    if (controlDigit !== lastDigit) {
      return false;
    }

    return true;
  } else {
    return true;
  }
};

const validateCNAE = (value) => {
  if (value != "") {
    value = value.replace(/\s/g, "");
    if (/^[0-9]{4}[A-Z]{1}$/.test(value)) {
      let firstDigit = parseInt(value.charAt(0));
      if (firstDigit < 1 || firstDigit > 9 || firstDigit === 8) {
        return false;
      }
      let cnaeNumber = parseInt(value.substring(0, 3));
      if (cnaeNumber < 1 || cnaeNumber > 981) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
};

export default {
  name: "ContractFilters",
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    DatePicker,
    VueNextSelect,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: "",
      contractNumber: "",
      from: "",
      to: "",
      surnames: "",
      shop: "",
      documentNumber: "",
      documentNumberCompany: "",
      CNAENumber: "",
      status: "",
      typeStatus: "",
      subtypeStatus: "",
      statusName: "",
      channel: "",
      tenant: "",
      modelConfig: {
        type: "string",
        mask: "DD/MM/YYYY",
      },
      advancedSearch: false,
      imei: "",
      policy: "",
      tenants: ["Rentik", "Butik", "Tecalis"],
      merchant: "",
      mobile: "",
      email: "",
      direction: "",
      realEndDateFrom: "",
      realEndDateTo: "",
      reasonAccepted: "",
      reasonAcceptedData: ["INCOFISA", "HOCELOT", "BANKREADER", "BALANCE AVAILABLE", "TRUSTWORTHY"],
      channelsData: ["WEB", "POS", "PHYS"],
      tenantsData: [],
      statusData: [],
      statusDescriptions: [],
      typeStatusData: [],
      subtypeStatusData: [],
      selectedValue: "",
      addStatuses: [],
      statusObject: {},
      loadingButton: false,
    };
  },
  validations() {
    return {
      documentNumber: {
        dniOrCifNumber,
      },
      documentNumberCompany: {
        validateCIF,
      },
      CNAENumber: {
        validateCNAE,
      },
    };
  },
  created() {
    this.loadTenantData();
    this.loadStatusData();
  },
  computed: {
    filtersApplied() {
      console.log('[ContractListFilters] Filtros aplicados:', {
        name: this.name,
        contractNumber: this.contractNumber,
        from: this.from,
        to: this.to,
        surnames: this.surnames,
        shop: this.shop,
        documentNumber: this.documentNumber,
        documentNumberCompany: this.documentNumberCompany,
        CNAENumber: this.CNAENumber,
        statusName: this.statusName,
        status: this.status,
        imei: this.imei,
        policy: this.policy,
        merchant: this.merchant,
        mobile: this.mobile,
        email: this.email,
        direction: this.direction,
        channel: this.channel,
        tenant: this.tenant,
        typeStatus: this.typeStatus,
        subtypeStatus: this.subtypeStatus,
        realEndDateFrom: this.realEndDateFrom,
        realEndDateTo: this.realEndDateTo,
        reasonAccepted: this.reasonAccepted,
      });
      return {
        name: this.name,
        contractNumber: this.contractNumber,
        from: this.from,
        to: this.to,
        surnames: this.surnames,
        shop: this.shop,
        documentNumber: this.documentNumber,
        documentNumberCompany: this.documentNumberCompany,
        CNAENumber: this.CNAENumber,
        statusName: this.statusName,
        status: this.status,
        imei: this.imei,
        policy: this.policy,
        merchant: this.merchant,
        mobile: this.mobile,
        email: this.email,
        direction: this.direction,
        channel: this.channel,
        tenant: this.tenant,
        typeStatus: this.typeStatus,
        subtypeStatus: this.subtypeStatus,
        realEndDateFrom: this.realEndDateFrom,
        realEndDateTo: this.realEndDateTo,
        reasonAccepted: this.reasonAccepted,
      };
    },
  },
  methods: {
    filter() {
      this.loadingButton = true;
      this.addStatuses = [];
      if (this.statusName != "") {
        for (let index = 0; index < this.statusName.length; index++) {
          let indexStatus = this.statusDescriptions.indexOf(
              this.statusName[index]
          );
          this.status = this.statusData[indexStatus];
          this.addStatuses.push(this.status);
        }
      }
      this.status = this.addStatuses.toString();
      console.log('[ContractListFilters] Ejecutando búsqueda con filtros:', this.filtersApplied);
      this.$emit("filter", this.filtersApplied);
      this.$nextTick(() => {
        this.loadingButton = false;
      });
    },
    loadTenantData() {
      axios.get(`/tenants`).then((response) => {
        let arrayTenant = [];
        response.data.forEach((element) => {
          arrayTenant.push(element.nameNormalized);
        });
        this.tenantsData = arrayTenant;
      });
    },
    filterSubTypeStatusData() {
      let arraySubtype = [];
      if (this.typeStatus != "") {
        this.statusObject.forEach((data) => {
          if (arraySubtype.indexOf(data.subType) === -1 && data.type == this.typeStatus) {
            arraySubtype.push(data.subType);
          }
        });
      } else {
        this.statusObject.forEach((data) => {
          if (arraySubtype.indexOf(data.subType) === -1) {
            arraySubtype.push(data.subType);
          }
        });
      }
      this.subtypeStatusData = arraySubtype;
      this.filterStatusData();
    },
    filterStatusData() {
      let arrayStatus = [];
      let arrayStatusDescription = [];
      if (this.subtypeStatus != "") {
        this.statusObject.forEach((data) => {
          if (data.subType == this.subtypeStatus) {
            arrayStatus.push(data.name);
            arrayStatusDescription.push(data.statusDescription);
          }
        });
      } else if (this.typeStatus != "") {
        this.statusObject.forEach((data) => {
          if (data.type == this.typeStatus) {
            arrayStatus.push(data.name);
            arrayStatusDescription.push(data.statusDescription);
          }
        });
      } else {
        arrayStatus = this.statusData;
        arrayStatusDescription = this.statusDescriptions;
      }
      this.statusData = arrayStatus;
      this.statusDescriptions = arrayStatusDescription;
    },
    loadStatusData() {
      let url = `/contract/status-list`;
      if (this.$store.state.roles.Backoffice_member_empresas) {
        url = `/business/contract/status`;
      }
      axios.get(url).then((response) => {
        let arrayStatus = [];
        let arrayDescriptions = [];
        let arrayType = [];
        let arraySubtype = [];
        this.statusObject = response.data;
        this.statusObject.forEach((element) => {
          arrayStatus.push(element.name);
          arrayDescriptions.push(element.statusDescription);
          if (arrayType.indexOf(element.type) === -1) {
            arrayType.push(element.type);
          }
          if (arraySubtype.indexOf(element.subType) === -1) {
            arraySubtype.push(element.subType);
          }
        });
        this.statusData = arrayStatus;
        this.statusDescriptions = arrayDescriptions;
        this.typeStatusData = arrayType;
        this.subtypeStatusData = arraySubtype;
        if (this.filterURL && this.filterURL !== "") {
          let indexStatus = this.statusData.indexOf(decodeURIComponent(this.filterURL));
          let filterURLEsp = this.statusDescriptions[indexStatus];
          this.$nextTick(() => {
            this.statusName = [filterURLEsp];
          });
          this.$nextTick(() => {
            this.filter();
          });
        }
      });
    },
    cleanSearch() {
      this.name = "";
      this.contractNumber = "";
      this.from = "";
      this.to = "";
      this.surnames = "";
      this.shop = "";
      this.documentNumber = "";
      this.documentNumberCompany = "";
      this.CNAENumber = "";
      this.statusName = "";
      this.status = "";
      this.imei = "";
      this.policy = "";
      this.merchant = "";
      this.mobile = "";
      this.email = "";
      this.direction = "";
      this.channel = "";
      this.tenant = "";
      this.typeStatus = "";
      this.subtypeStatus = "";
      this.realEndDateFrom = "";
      this.realEndDateTo = "";
      this.reasonAccepted = "";
      this.filterStatusData();
      this.filterSubTypeStatusData();
      this.filtersApplied = {
        name: "",
        contractNumber: "",
        from: "",
        to: "",
        surnames: "",
        shop: "",
        documentNumber: "",
        documentNumberCompany: "",
        CNAENumber: "",
        status: "",
        imei: "",
        policy: "",
        merchant: "",
        mobile: "",
        email: "",
        direction: "",
        channel: "",
        tenant: "",
        typeStatus: "",
        subtypeStatus: "",
        realEndDateFrom: "",
        realEndDateTo: "",
        reasonAccepted: "",
      };
      this.addStatuses = [];
      console.log('[ContractListFilters] Limpieza de filtros realizada');
    },
    enterKey: function (e) {
      if (e.keyCode === 13) {
        this.filter();
        this.channel = "";
        this.tenant = "";
      }
    },
    advancedSearchToggle() {
      this.advancedSearch = !this.advancedSearch;
    },
  },
};
</script>

<style lang="scss">
@import '../../../scss/variables.scss';

.filterHeader {
  font-size: 1.143rem;
  line-height: 1.5;
}

.link-primary {
  color: $primary;
  cursor: pointer;

  &:hover {
    color: $primary-hover;
  }
}

.multipleSelect .generalInput {
  padding-right: 27px;
}

.multipleSelect .multiSelect .vue-select-input-wrapper {
  padding-top: 15px;
  .vue-input {
    z-index: 9999;
    border: 1px solid #e5e4e4;
    background-color: #ffff;
    input {
      font-size: 1.1rem;
    }
  }
}

.multipleSelect .multiSelect .vue-dropdown {
  margin-top: 2px;
  border-top: 55px solid #ffff;
}
</style>
